export default "__VITE_ASSET__EPn9Dg30__"